import { TestLayerLabel, TestLayerValue, TestMode, TestModeLabel } from '@nrwl/common-lib';

export const Y1564ConfigFieldMapping = {
  //setup
  ALIAS: 'alias',
  CUSTOMER: 'customer',
  CONTACT: 'contact',
  EMAIL: 'email',
  PHONE: 'phone',
  TECHINICIAN: 'technician',
  TECHINICIANID: 'technicianId',
  COMMENTS: 'comments',
  ENGINE_A_INFO: 'engine-a-info',
  ENGINE_B_INFO: 'engine-b-info',
  TEST_MODE: 'mode',
  LAYER_TO_TEST: 'layer',
  IP_ADDRESS_TYPE: 'ip-address-type',
  STREAM_RATE_CONVENTION: 'unit-convention',
  RUN_PERF_TEST: 'run-perf-test',
  PERF_TEST_DURATION: 'perf-test-duration',
  PERF_TEST_CUSTOM_DURATION: 'perf-test-custom-duration',
  NUMBER_OF_STEPS: 'number-of-steps',
  RUN_CONFIG_TEST: 'run-config-test',
  STEP_DURATION: 'step-duration',
  STEP_PERCENTS: 'step-percents',
  REVERSE_STEPS: 'ramp-up',
  ABORT_ON_FAILURE: 'abort-on-failure',
  RUN_TYPE: 'runType',
  SCHEDULER: 'scheduler',
  SELECTED_ORIGINATOR: 'selectedOriginator',
  SELECTED_DESTINATION: 'selectedDestination',

  //endpoints
  AGENT_TYPE: 'agentType',
  FRAME_LOSS_INTERVAL: 'frame-loss-interval',
  DEFINED_ADDRESS: 'definedAddress',
  SOURCE_ADDRESS_FROM: 'sourceAddress',
  SUPPRESS_LOOP_COMMANDS: 'suppress-loop-commands',
  SWAP_MAC_ADDRESS: 'swap-addresses',
  SEND_PRIMING_PACKETS: 'send-priming-packets',
  VLAN_CONFIG: 'vlanConfig',
  ETHER_TYPE: 'ether-type',
  CVLAN_ETHER_TYPE: 'inner-ether-type',
  VLAN_ENABLED: 'vlanEnabled',
  SVLAN_ID: 'vlan-id',
  CVLAN_ID: 'inner-vlan-id',
  VERIFY_PRIORITY: 'filter-on-priority',
  VLAN_DEFINED: 'vlanDefinedForEachService',
  ETHER_TYPE_DEFINED: 'etherTypeDefinedForEachService',
  SRC_EDIT_LAYER_2_IP: 'srcEditLayer2IP',
  SRC_EDIT_LAYER_3_IP: 'srcEditLayer3IP',
  SRC_EDIT_LAYER_2_MAC: 'srcEditLayer2MAC',
  SRC_EDIT_LAYER_3_MAC: 'srcEditLayer3MAC',
  SRC_MAC_ADDRESS: 'source-mac',
  SRC_NETWORK_MAC: 'srcNetworkMacAddress',
  SRC_EQUIPMENT_MAC: 'srcEquipmentMacAddress',
  SRC_TEST_IP_ADDRESS: 'srcTestIpAddress',
  SRC_ASSIGNED_IP_ADDRESS: 'srcAssignedIpAddress',
  SRC_IPV4_ADDRESS: 'test-ip',
  SRC_IPV6_ADDRESS: 'source-ipv6-address',
  SRC_SUBNET: 'test-subnet-mask',
  SRC_GATEWAY: 'test-gateway',
  TRANSMIT_INTERFACE: 'tx-interface',
  DEST_EDIT_IP: 'destEditIP',
  DEST_EDIT_MAC: 'destEditMAC',
  DEST_SUBNET: 'destSubnet',
  DEST_IPV4_ADDRESS: 'destination-ip',
  DEST_IPV6_ADDRESS: 'dest-ipv6-address',
  DEST_GATEWAY: 'destGateway',
  DEST_TRANSMIT_INTERFACE: 'dest-tx-interface',
  DEST_DEFINED_ADDRESS: 'dest-definedAddress',
  REMOTE_VLAN_TAG: 'remote-tag-count',
  DEST_SHOW_IP_LAYER2: 'destShowIpWithLayer2',
  DEST_SHOW_MAC_LAYER3: 'destShowMacWithLayer3',
  USE_ARP: 'arp-mode',
  DESTINATION_MAC: 'destination-mac',
  DEI_ENABLE: 'deiEnable',

  //streams
  STREAMS: 'streams',
  STREAM_NUMBER: 'stream-number',
  STREAM_NAME: 'name',
  CIR: 'cir-from-engine-a',
  CIR2: 'cir-from-engine-b',
  EIR: 'eir-from-engine-a',
  EIR2: 'eir-from-engine-b',
  POLICING: 'run-policing-from-engine-a',
  POLICING2: 'run-policing-from-engine-b',
  MAX_IR: 'max-ir-from-engine-a',
  MAX_IR2: 'max-ir-from-engine-b',
  FD: 'frame-delay-threshold',
  FDV: 'latency-FDV-maximum',
  LOSS: 'frame-loss-ratio-threshold',
  CBS: 'cbs-size',
  KB_SIZE: 'cbs-kilo-size',
  CBS_REPETITIONS: 'cbs-number-of-reps',
  CBS_LINE_RATE: 'cbs-remote-line-rate',
  ENABLE_FRAME_DELAY: 'enable-frame-delay',
  VALID_FRAME_SIZE: 'validFrameSizes',
  VALID_FRAME_SIZE_SINGLE: 'validFrameSizesSingle',
  VALID_FRAME_SIZE_DOUBLE: 'validFrameSizesDouble',
  SCT_FRAME_SIZE: 'sct-frame-size-list',
  SPT_FRAME_SIZE: 'spt-frame-size-list',
  SVLAN_PRIORITY: 'vlan-priority',
  CVLAN_PRIORITY: 'inner-vlan-priority',
  ERROR_ON_OSS: 'fail-on-OOS',
  MAX_SERVICES: 'maxServices',
  DSCP: 'dscp',
  TTL: 'ttl',
  TOS: 'tos',
  FLOW_LABEL: 'flow-label',
  TRAFFIC_CLASS: 'traffic-class',
  HOP_LIMIT: 'hop-limit',
  PAYLOAD_TYPE: 'payload',
  OVER_HEAD_BYTES: 'overhead-byte-count',
  BI_DIRECTIONAL: 'bi_directional',
  MAX_BANDWIDTH: 'max_bandwidth',
  DEVICE_SELECTION_METHOD: 'device-selection-method',
  FRAME_LENGTH: 'frame-length',
  FRAME_TYPE: 'frame_type',
  VERIFY_DSCP: 'filter-on-tos',
  FRAME_LIST: 'frame-list',
  STREAM_IN_USE: 'stream-in-use'
};

export enum IPAddressLabel {
  IP_V4 = 'IPv4',
  IP_V6 = 'IPv6'
}

export enum IPAddressValue {
  IP_V4 = 'ipv4',
  IP_V6 = 'ipv6'
}

export enum streamRateConventionLabel {
  L1 = 'L1 Mbps (ULR)',
  L2 = 'L2 Mbps (IR)'
}

export enum streamRateConventionValue {
  L1 = 'l1-mbps',
  L2 = 'l2-mbps'
}

export enum frameLossIntervalLabel {
  peak = 'Peak 1 second',
  overall = 'Overall test'
}

export enum frameLossIntervalValue {
  peak = 'peak',
  overall = 'overall'
}

export enum definedAddressLabel {
  TEST_IP = 'Test IP',
  MANAGEMENT_IP = 'Management IP',
  MANUAL = 'Manual'
}

export enum definedAddressValue {
  TEST_IP = 'testIP',
  MANAGEMENT_IP = 'managed',
  MANUAL = 'manual'
}

export enum sourceAddressFrom {
  MANUAL = 'manual',
  DHCP = 'DHCP'
}

export enum vlanConfigLabel {
  UNTAGGED = 'Untagged',
  SINGLE_VLAN = 'Single VLAN',
  Q_IN_Q = 'Q-in-Q'
}

export enum vlanConfigValue {
  UNTAGGED = 'untagged',
  SINGLE_VLAN = 'tagged',
  Q_IN_Q = 'q_in_q'
}

export enum TRANSMIT_INTERFACE_LABEL {
  EQUIPMENT = 'Equipment',
  NETWORK = 'Network'
}

export enum TRANSMIT_INTERFACE_VALUE {
  EQUIPMENT = 'equipment',
  NETWORK = 'network'
}

export enum TX_IMAGE {
  EQUIPMENT = 'images/equipment.png',
  NETWORK = 'images/network.png'
}

export enum REMOTE_VLAN_TAG_COUNT_LABEL {
  NO_VLAN = 'No VLAN Tags',
  ONE_VLAN = '1 VLAN Tag',
  TWO_VLAN = '2 VLAN Tags'
}

export enum PAYLOAD_TYPE_LABEL {
  FILL = 'Fill byte',
  PRBS = 'PRBS'
}

export enum PAYLOAD_TYPE_VALUE {
  FILL = 'fill-byte',
  PRBS = 'prbs'
}

export enum ETHER_TYPE_LABEL {
  ETHER_8100 = '8100',
  ETHER_88a8 = '88a8',
  ETHER_9100 = '9100'
}

export const IP_ADDRESS_TYPE = [
  { name: IPAddressLabel.IP_V4, value: IPAddressValue.IP_V4 },
  { name: IPAddressLabel.IP_V6, value: IPAddressValue.IP_V6 }
];

export const STREAM_RATE_TYPE = [
  { name: streamRateConventionLabel.L2, value: streamRateConventionValue.L2 },
  { name: streamRateConventionLabel.L1, value: streamRateConventionValue.L1 }
];

export const FRAME_LOSS_TYPE = [
  { name: frameLossIntervalLabel.peak, value: frameLossIntervalValue.peak },
  { name: frameLossIntervalLabel.overall, value: frameLossIntervalValue.overall }
];

export const VLAN_CONFIG_TYPE = [
  { name: vlanConfigLabel.UNTAGGED, value: vlanConfigValue.UNTAGGED },
  { name: vlanConfigLabel.SINGLE_VLAN, value: vlanConfigValue.SINGLE_VLAN },
  { name: vlanConfigLabel.Q_IN_Q, value: vlanConfigValue.Q_IN_Q }
];

export const SVLAN_ETHER_TYPE = [
  {
    name: ETHER_TYPE_LABEL.ETHER_8100,
    value: ETHER_TYPE_LABEL.ETHER_8100,
    vlanType: vlanConfigValue.SINGLE_VLAN
  },
  {
    name: ETHER_TYPE_LABEL.ETHER_88a8,
    value: ETHER_TYPE_LABEL.ETHER_88a8,
    vlanType: vlanConfigValue.Q_IN_Q
  }
];

export const CVLAN_ETHER_TYPE = [{ name: '8100', value: '8100' }];

export const TRANSMIT_INTERFACE_TYPE = [
  { name: TRANSMIT_INTERFACE_LABEL.EQUIPMENT, value: TRANSMIT_INTERFACE_VALUE.EQUIPMENT },
  { name: TRANSMIT_INTERFACE_LABEL.NETWORK, value: TRANSMIT_INTERFACE_VALUE.NETWORK }
];

export const REMOTE_VLAN_TAG_COUNT_TYPE = [
  { name: REMOTE_VLAN_TAG_COUNT_LABEL.NO_VLAN, value: 0, vlanType: vlanConfigValue.UNTAGGED },
  { name: REMOTE_VLAN_TAG_COUNT_LABEL.ONE_VLAN, value: 1, vlanType: vlanConfigValue.SINGLE_VLAN },
  { name: REMOTE_VLAN_TAG_COUNT_LABEL.TWO_VLAN, value: 2, vlanType: vlanConfigValue.Q_IN_Q }
];

export const PAYLOAD_TYPE = [
  { name: PAYLOAD_TYPE_LABEL.FILL, value: PAYLOAD_TYPE_VALUE.FILL },
  { name: PAYLOAD_TYPE_LABEL.PRBS, value: PAYLOAD_TYPE_VALUE.PRBS }
];

export const CONFIRM_SELECTION = [
  { name: 'Yes', value: true },
  { name: 'No', value: false }
];

export const LOOP_UP_SELECTION = [
  { name: 'Yes', value: true },
  { name: 'No', value: false }
];

export const REVERSE_CONFIRM_SELECTION = [
  { name: 'Yes', value: false },
  { name: 'No', value: true }
];

export const LAYER_TYPES = [
  { name: TestLayerLabel.L2, value: TestLayerValue.L2 },
  { name: TestLayerLabel.L3, value: TestLayerValue.L3 }
];

export const MTS_LAYER_TYPES = [{ name: TestLayerLabel.L4, value: TestLayerValue.L4 }];

export const ERROR_ON_OSS = [
  { name: 'Yes', value: true },
  { name: 'No', value: false }
];
export const KILOBYTE_TYPE = [
  { name: '1000', value: 'cbs1000' },
  { name: '1024', value: 'cbs1024' }
];
export const ACCESSRATE_TYPE = [
  { name: '10 Mbps', value: 'Mbps10' },
  { name: '100 Mbps', value: 'Mbps100' },
  { name: '1 Gbps', value: 'Mbps1000' },
  { name: '10 Gbps', value: 'Mbps10000' }
];
export const DSCP_CONFIG_TYPE = [
  {
    value: 'Best effort (0)',
    id: 0
  },
  {
    value: 'Class Selector 1 (8)',
    id: 32
  },
  {
    value: 'AF 11 (10)',
    id: 40
  },
  {
    value: 'AF 12 (12)',
    id: 48
  },
  {
    value: 'AF 13 (14)',
    id: 56
  },
  {
    value: 'Class Selector 2 (16)',
    id: 64
  },
  {
    value: 'AF 21 (18)',
    id: 72
  },
  {
    value: 'AF 22 (20)',
    id: 80
  },
  {
    value: 'AF 23 (22)',
    id: 88
  },
  {
    value: 'Class Selector 3 (24)',
    id: 96
  },
  {
    value: 'AF 31 (26)',
    id: 104
  },
  {
    value: 'AF 32 (28)',
    id: 112
  },
  {
    value: 'AF 33 (30)',
    id: 120
  },
  {
    value: 'Class Selector 4 (32)',
    id: 128
  },
  {
    value: 'AF 41 (34)',
    id: 136
  },
  {
    value: 'AF 42 (36)',
    id: 144
  },
  {
    value: 'AF 43 (38)',
    id: 152
  },
  {
    value: 'Class Selector 5 (40)',
    id: 160
  },
  {
    value: 'AF 51 (42)',
    id: 168
  },
  {
    value: 'AF 52 (52)',
    id: 176
  },
  {
    value: 'Exp. Forwarding (46)',
    id: 184
  },
  {
    value: 'Class Selector 6 (48)',
    id: 192
  },
  {
    value: 'Class Selector 7 (56)',
    id: 224
  }
];

export const SVLAN_PRIORITY_TYPE = [
  {
    value: 'Pri-0',
    id: 0
  },
  {
    value: 'Pri-1',
    id: 1
  },
  {
    value: 'Pri-2',
    id: 2
  },
  {
    value: 'Pri-3',
    id: 3
  },
  {
    value: 'Pri-4',
    id: 4
  },
  {
    value: 'Pri-5',
    id: 5
  },
  {
    value: 'Pri-6',
    id: 6
  },
  {
    value: 'Pri-7',
    id: 7
  }
];
export const CVLAN_PRIORITY_TYPE = [
  {
    value: 'Pri-0',
    id: 0
  },
  {
    value: 'Pri-1',
    id: 1
  },
  {
    value: 'Pri-2',
    id: 2
  },
  {
    value: 'Pri-3',
    id: 3
  },
  {
    value: 'Pri-4',
    id: 4
  },
  {
    value: 'Pri-5',
    id: 5
  },
  {
    value: 'Pri-6',
    id: 6
  },
  {
    value: 'Pri-7',
    id: 7
  }
];

export const DEFINED_ADDRESS_TYPES = [
  { name: definedAddressLabel.TEST_IP, value: definedAddressValue.TEST_IP, enabled: true },
  {
    name: definedAddressLabel.MANAGEMENT_IP,
    value: definedAddressValue.MANAGEMENT_IP,
    enabled: true
  },
  { name: definedAddressLabel.MANUAL, value: definedAddressValue.MANUAL, enabled: true }
];

export const SOURCE_ADDRESS_FROM = [
  { name: 'Manual', value: sourceAddressFrom.MANUAL },
  { name: 'DHCP', value: sourceAddressFrom.DHCP }
];

export const SUBNET_MAP = {
  '1': '128.0.0.0',
  '2': '192.0.0.0',
  '3': '224.0.0.0',
  '4': '240.0.0.0',
  '5': '248.0.0.0',
  '6': '252.0.0.0',
  '7': '254.0.0.0',
  '8': '255.0.0.0',
  '9': '255.128.0.0',
  '10': '255.192.0.0',
  '11': '255.224.0.0',
  '12': '255.240.0.0',
  '13': '255.248.0.0',
  '14': '255.252.0.0',
  '15': '255.254.0.0',
  '16': '255.255.0.0',
  '17': '255.255.128.0',
  '18': '255.255.192.0',
  '19': '255.255.224.0',
  '20': '255.255.240.0',
  '21': '255.255.248.0',
  '22': '255.255.252.0',
  '23': '255.255.254.0',
  '24': '255.255.255.0',
  '25': '255.255.255.128',
  '26': '255.255.255.192',
  '27': '255.255.255.224',
  '28': '255.255.255.240',
  '29': '255.255.255.248',
  '30': '255.255.255.252',
  '31': '255.255.255.254',
  '32': '255.255.255.255'
};

export const PERF_TEST_DURATIONS = [
  { name: '1 minute', value: 60 },
  { name: '15 minutes', value: 900 },
  { name: '2 Hours', value: 7200 },
  { name: '24 Hours', value: 86400 },
  { name: 'User Defined', value: 'custom' }
];

export const SCHEDULER_ENDS_DURATIONS = [
  { name: '1 minute', value: 60 },
  { name: '5 minute', value: 300 },
  { name: '15 minutes', value: 900 },
  { name: '1 Hours', value: 3600 },
  { name: '2 Hours', value: 7200 },
  { name: '24 Hours', value: 86400 }
];

export const TEST_MODE_TYPES = [
  { name: TestModeLabel.LOOPBACK, value: TestMode.LOOPBACK },
  { name: TestModeLabel.MA_TO_MA, value: TestMode.UNIDIRECIONAL },
  { name: TestModeLabel.SEQUENTIAL, value: TestMode.SEQUENTIAL },
  { name: TestModeLabel.CONCURRENT, value: TestMode.CONCURRENT }
];
export const DEFAULT_STREAM = [
  {
    'stream-number': 1,
    name: 'service 1',
    'cir-from-engine-a': 10,
    'eir-from-engine-a': 0,
    'run-policing-from-engine-a': false,
    'max-ir-from-engine-a': null,
    'frame-loss-ratio-threshold': 0,
    'spt-frame-size-list': '512',
    'sct-frame-size-list': '512',
    tos: 184,
    ttl: 255,
    'frame-list': null,
    'stream-in-use': true
  }
];

export const JMEP_STREAM = [
  {
    'stream-number': 1,
    name: 'service 1',
    'cir-from-engine-a': 10,
    'eir-from-engine-a': 0,
    'run-policing-from-engine-a': false,
    'max-ir-from-engine-a': null,
    'frame-loss-ratio-threshold': 0,
    'latency-FDV-maximum': 100,
    'frame-delay-threshold': 100,
    'spt-frame-size-list': '512',
    'sct-frame-size-list': '512',
    'fail-on-OOS': true,
    'vlan-priority': 0,
    'inner-vlan-priority': 0,
    'filter-on-tos': false,
    'overhead-byte-count': 0,
    //ipv4
    tos: 184,
    ttl: 32,
    //ipv6
    'flow-label': 1,
    'traffic-class': '00',
    'hop-limit': 64,
    'frame-list': null,
    'stream-in-use': true
  }
];

export const QT_STREAM = [
  {
    'stream-number': 1,
    name: 'service 1',
    'cir-from-engine-a': 10,
    'eir-from-engine-a': 0,
    'run-policing-from-engine-a': false,
    'max-ir-from-engine-a': null,
    'frame-loss-ratio-threshold': 0,
    'latency-FDV-maximum': 100,
    'frame-delay-threshold': 100,
    'spt-frame-size-list': '512',
    'sct-frame-size-list': '512',
    'vlan-priority': 0,
    'inner-vlan-priority': 0,
    //cbs fields
    'cbs-size': 0,
    'cbs-number-of-reps': 1,
    'cbs-kilo-size': 'cbs1000',
    'cbs-remote-line-rate': 'Mbps1000',
    'fail-on-OOS': true,
    'filter-on-tos': false,
    //ipv4
    tos: 184,
    ttl: 255,
    //ipv6
    'flow-label': 1,
    'traffic-class': '00',
    'hop-limit': 64,
    'frame-list': null,
    'stream-in-use': true
  }
];

export const LOOPBACK_VTA_STREAM = [
  {
    'stream-number': 1,
    name: 'service 1',
    'cir-from-engine-a': 10,
    'eir-from-engine-a': 0,
    'run-policing-from-engine-a': false,
    'max-ir-from-engine-a': null,
    'frame-loss-ratio-threshold': 0,
    'frame-delay-threshold': 100,
    'spt-frame-size-list': '512',
    'sct-frame-size-list': '512',
    payload: 'fill-byte',
    //ipv4
    tos: 184,
    ttl: 255,
    'frame-list': null,
    'stream-in-use': true
  }
];

export const AGENT_AGENT_STREAM = [
  {
    'stream-number': 1,
    name: 'service 1',
    'cir-from-engine-a': 10,
    'eir-from-engine-a': 0,
    'run-policing-from-engine-a': false,
    'max-ir-from-engine-a': null,
    'frame-loss-ratio-threshold': 0,
    'spt-frame-size-list': '512',
    'sct-frame-size-list': '512',
    payload: 'fill-byte',
    //ipv4
    tos: 184,
    ttl: 255,
    'frame-list': null,
    'stream-in-use': true
  }
];

export const BIDirectional_VTA_STREAM = [
  {
    'stream-number': 1,
    name: 'service 1',
    'cir-from-engine-a': 10,
    'cir-from-engine-b': 10,
    'eir-from-engine-a': 0,
    'eir-from-engine-b': 0,
    'run-policing-from-engine-a': false,
    'run-policing-from-engine-b': false,
    'max-ir-from-engine-a': null,
    'max-ir-from-engine-b': null,
    'frame-loss-ratio-threshold': 0,
    'spt-frame-size-list': '512',
    'sct-frame-size-list': '512',
    payload: 'fill-byte',
    //ipv4
    tos: 184,
    ttl: 255,
    'frame-list': null,
    'stream-in-use': true
  }
];

export const MAP_STREAM = [
  {
    'stream-number': 1,
    name: 'service 1',
    'cir-from-engine-a': 10,
    'eir-from-engine-a': 0,
    'run-policing-from-engine-a': false,
    'max-ir-from-engine-a': null,
    'frame-loss-ratio-threshold': 0,
    'latency-FDV-maximum': 100,
    'frame-delay-threshold': 100,
    'spt-frame-size-list': '512',
    'sct-frame-size-list': '512',
    payload: 'fill-byte',
    'vlan-priority': 0,
    'inner-vlan-priority': 0,
    //Layer3
    tos: 184,
    ttl: 255,
    'frame-list': null,
    'stream-in-use': true
  }
];
export const MTS_STREAM = [
  {
    'stream-number': 1,
    name: 'service 1',
    'cir-from-engine-a': 10,
    'eir-from-engine-a': 0,
    'run-policing-from-engine-a': false,
    'max-ir-from-engine-a': null,
    'frame-loss-ratio-threshold': 0,
    'latency-FDV-maximum': 100,
    'frame-delay-threshold': 100,
    'spt-frame-size-list': '512',
    'sct-frame-size-list': '512',
    payload: 'fill-byte',
    'vlan-priority': 0,
    'inner-vlan-priority': 0,
    'frame-list': null,
    'stream-in-use': true
  }
];
export const TOO_MANY_STREAMS_ERROR_MSG =
  'No VLAN set in VLAN Config, only one stream can be tested in this mode. You can fix this by adding a VLAN or by removing streams.';
